<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	// Design system components
	import { FullScreenContainer, Text, Stack } from '@Shelly/shelly-design-system';
	//Helpers
	import { translateThermostat } from '../helpers/temp_scheme_to_ui';
	import { temp_schemes } from 'src/stores/lists/scenes-derived';
	//Components
	import TempSchemeChart from '../../Chart/TempSchemeChart.svelte';
	import IntervalPreview from '../components/IntervalPreview.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let id: string;
	let forceEnabled = true;

	$: data = translateThermostat($temp_schemes[id]);
</script>

<FullScreenContainer class="mb-m" backgroundColor={$showNewLayout ? 'color-0' : undefined}>
	<Text styleType="h2" slot="title" class="text-capitalize" noWrap>
		{$format('temperature_schedule', { default: 'temperature schedule' })}
	</Text>
	<TempSchemeChart {data} {forceEnabled} />
</FullScreenContainer>

{#key data}
	<Stack gap="s" class="mb-m">
		{#each data.intervals as interval}
			<IntervalPreview units={data.units} {interval} />
		{/each}
	</Stack>
{/key}
